export const getSSRPage = state => state.ssr.ssrPage;
export const getDomain = state => state.ssr.domain;
